import React,{useState} from 'react'
import { FaRegCopy ,FaCheck} from "react-icons/fa";

const SubmissionForm = () => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    setCopied(true);
    const email = "2024nationalconvention@gmail.com";
    navigator.clipboard.writeText(email);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  }
    
  return (
    <div className="shadow drop-shadow-sm bg-white p-8 mt-32 font-textFont rounded-lg">
    <h2 className='text-4xl text-textmain font-semibold text-center mb-4'>Submission</h2>
    <h2 className='note text-xl text-textmain'>
        <span className='font-bold'>NOTE: </span>
        <span className='text text-black'>Before Submission, Payment must be Done.</span>
    </h2>

    <div className="flex flex-row items-center space-y-4 p-4 bg-gray-100 rounded-lg shadow-md">
      <div className='w-1/2'>
        <h2 className="text-2xl font-bold text-textmain">Instruction to submit the Paper</h2>
        <p className="text-lg">The Submisson must done to the below Email ID with below Details:</p>
        <ul className="list-disc list-inside text-left">
          <li>Author Name</li>
          <li>Corresponding Author Affiliation</li>
          <li>Email</li>
          <li>Phone No</li>
          <li>Paper Title</li>
          <li>Abstract</li>
          <li>Conference Paper(*pdf)</li>
          <li>Proof of Transaction(*pdf)</li>
        </ul>
      </div>
      <div className="flex flex-col items-center w-1/2">
        <h3 className="text-lg font-medium text-gray-800">Email to:</h3>
        <div className="flex items-center font-semibold font-textFont bg-gray-200 py-4 m-2 px-2 rounded-lg">
          <code id="email" className="text-maroon">2024nationalconvention@gmail.com</code>
          <button onClick={copyToClipboard} className="ml-2 p-2 text-xl text-gray-600 hover:text-olive">
            {copied ? 
            <FaCheck style={{ color: 'green' }} /> : <FaRegCopy />}
          </button>
        </div>
      </div>

    </div>

    </div>
  )
}

export default SubmissionForm